import { CREATE_SESSION, CLOSE_SESSION } from '../constants';
const INITIAL_STATE = []

const sessionReducer = (state=INITIAL_STATE, action) => {
    switch(action.type){
        case CREATE_SESSION:
        return Object.assign({},
            action.session,
            {
            valid: true,
            createdAt: Date.now()
            }
        )
        case CLOSE_SESSION:
        return Object.assign({},
            state,
            {
            valid: false,
            login: undefined
            }
        )
        default:
        return state
    }
}

export default sessionReducer;